exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1BHxF {\n  display: block; }\n\n.actionButtons---3gK3n {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 250px; }\n\n.actionButtons---3gK3n div {\n    padding: 2px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1BHxF",
	"actionButtons": "actionButtons---3gK3n"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/containers/default-courses/index.scss
// module id = 765
// module chunks = 3